'use client';

import { createContext, useCallback, useContext, useState } from 'react';

import { ToastProps } from '@/shared/ui/toast';

type ToastContextProps = {
	toasts: ToastProps[];
	addToast: (title: string, text: string, type?: ToastProps['type']) => void;
};

export const ToastContext = createContext<ToastContextProps>({
	toasts: [],
	addToast: () => null,
});

export const useToast = () => {
	return useContext(ToastContext);
};

export const ToastProvider = ({ children }: React.PropsWithChildren) => {
	const [toasts, setToasts] = useState<ToastProps[]>([]);

	const addToast = useCallback(
		(title: string, text: string, type: ToastProps['type'] = 'info') => {
			const id = Date.now();
			const toast: ToastProps = { id, title, text, type };

			setToasts((prev) => [...prev, toast]);

			setTimeout(() => {
				setToasts((prevToasts) =>
					prevToasts.filter((toast) => toast.id !== id),
				);
			}, 7000);
		},
		[],
	);

	return (
		<ToastContext.Provider value={{ toasts, addToast }}>
			{children}
		</ToastContext.Provider>
	);
};
